import { create } from 'zustand'

interface CacheClearedStore {
    cacheClearedEvent: boolean
    
    // Marcar que se borró el caché
    setCacheCleared: () => void
    
    // Resetear el evento después de procesarlo
    resetCacheCleared: () => void
    
    // Obtener el estado actual
    isCacheCleared: () => boolean
}

export const useCacheClearedStore = create<CacheClearedStore>((set, get) => ({
    cacheClearedEvent: false,
    
    // Marcar que se borró el caché
    setCacheCleared: () => set({ cacheClearedEvent: true }),
    
    // Resetear el evento después de procesarlo
    resetCacheCleared: () => set({ cacheClearedEvent: false }),
    
    // Obtener el estado actual
    isCacheCleared: () => get().cacheClearedEvent,
}))
